import { Activity, memo } from "react";
import { Pagination } from "@ir/ui";
import PageFooter from "@/presentation/ui/layouts/page/PageFooter";

interface PromotionsPaginationProps {
  hasPagination: boolean;
  totalCount: number;
  pageLimit: number;
  currentPage: number;
  isLoading: boolean;
  onPageChange: (page: number) => void;
}

const PromotionsPagination = memo(
  ({ hasPagination, totalCount, pageLimit, currentPage, isLoading, onPageChange }: PromotionsPaginationProps) => (
    <Activity name="promotions-pagination" mode={hasPagination ? "visible" : "hidden"}>
      <PageFooter className="trade-promotions-page-footer">
        <Pagination
          totalItems={totalCount}
          itemsPerPage={pageLimit}
          currentPage={currentPage}
          onPageChange={onPageChange}
          isDisabled={isLoading}
        />
      </PageFooter>
    </Activity>
  )
);

PromotionsPagination.displayName = "PromotionsPagination";

export { PromotionsPagination };
